module.exports = __webpack_public_path__ + "img/night-bottom-bg_en.372b6853.png";